import * as commonPrintingUtilities from '../common/utils/printingUtilities';
import { image } from './chroniclerHeader';

const { genDocDefinitionFactory, ...others } = commonPrintingUtilities

export const genDocDefinition = genDocDefinitionFactory(image);

export const { base64Decode, getPNGDimensions, jpegProps, makeCell, makeImageCell, makeTitle, toInt32 } = others